/** The pricing context being inspected; each level resets the ones below it. */
export interface CalculationSelection {
  brandId: number | null;
  regionId: number | null;
  denominationId: number | null;
  paymentChannelCode: string | null;
  /** null = Auto: exactly what checkout does. */
  providerId: number | null;
}

export const EMPTY_SELECTION: CalculationSelection = {
  brandId: null,
  regionId: null,
  denominationId: null,
  paymentChannelCode: null,
  providerId: null,
};
